module.exports = __webpack_public_path__ + "static/media/remake.0bc180ca.png";